import {
    getReportRun,
    listReportRuns
} from './queries';
import {
    createReportRun,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {ReportRun} from "../types.ts";
import {generateClient} from "aws-amplify/api";


export type ListReportRuns = {
    listReportRuns: { items: ReportRun[], nextToken?: string }
}

export type GetReportRun = {
    getReportRun: ReportRun
}

export type CreateReportRun = {
    createReportRun: ReportRun
}

const client = generateClient();

/**
 * FNP-918: the `filter` argument is gone.
 *
 * ⚠️ This used to take a `filter: object` and send it as a GraphQL variable.
 * `listReportRuns` declares only `($limit: Int, $nextToken: String)` — see
 * queries.ts — so `filter` was an UNDECLARED variable. AppSync discards those
 * silently, which is the worst failure shape: the call site read as
 * server-side filtering, every caller passed `{}` into it, and nothing ever
 * narrowed anything. Removing the parameter makes the contract honest.
 *
 * Filtering and keyword search are client-side over the loaded window; see
 * hooks/useReportRuns.ts, which says so at the point a reader would ask.
 */
export const fetchRecords = async (limit?: number, nextToken?: string) => {
    const response = await client.graphql<GraphQLQuery<ListReportRuns>>({
                                                                            query: listReportRuns,
                                                                            variables: {limit, nextToken},
                                                                        });
    return response.data?.listReportRuns;
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetReportRun>>({
                                                                          query: getReportRun,
                                                                          variables: {id: id},
                                                                      });
    return response.data?.getReportRun;
};

export const add = async (payload: object) => {
    const response = await client.graphql<GraphQLQuery<CreateReportRun>>({
                                                                             query: createReportRun,
                                                                             variables: {input: payload},
                                                                         });
    return response.data?.createReportRun;
};
